import {log, logError} from '../webUtils'

import {
  selectECA,
  selectFunctionType, 
  addFunction, 
  deleteFunction,
  createFunction, 
  registerChildFunction, 
  openECAPanel
} from '../actions/triggerActions'
import {getDefaultArgs, getDefaultValue, getFunctionsOfType,
 reorderFunctions} from '../accessors/triggerAccessors'
import {getNewOrder} from '../accessors/accessors'

const defaultState = [];

const functions = (state = defaultState, action) => {
  switch (action.type) {
    case 'ADD_ECA':
      var id= Math.max(0, ...state.map(f => f.id)) + 1;
      if(action.functionType != 'EVENT' &&
        action.functionType != 'CONDITION' && 
        action.functionType != 'ACTION') {
        throw new Error ('ADD_ECA Action should be an EVENT, CONDITION or ACTION')
      }
      action.asyncDispatch(openECAPanel({id:id}));
      action.asyncDispatch(selectECA({id:id}));
      var newOrder = getNewOrder(getFunctionsOfType(state, 
        action.triggerId, action.functionType))
      return [...state,
        {
          id: id,
          parentId: null,
          functionType:action.functionType,
          triggerId:action.triggerId,
          order:newOrder,
          activityId: action.activityId,
          args:[
            {
              mode:'FUNCTION',
              functionId: id+1,
            },
          ]
        },
        {
          id: id+1,
          parentId: id,
          functionType:'NULL',
          triggerId:action.triggerId,
          activityId: action.activityId,
          args:[
            {
              mode:'NULL',
            },
          ]
        },
      ]
    case 'ADD_FUNCTION':
      var id = Math.max(0, ...state.map(f => f.id)) + 1;
      if(typeof action.parentId === 'undefined') {
        throw new Error ('Undefined parentId on the function');
      }
      // console.log('Add function ', action)
      action.asyncDispatch(registerChildFunction({...action, id:id}));
      return [...state,
        {
          id: id,
          parentId: action.parentId,
          functionType:action.functionType,
          triggerId:action.triggerId,
          activityId: action.activityId,
          args:getDefaultArgs(action.functionType),
        }
      ]
    case 'PUT_DOWN_FUNCTION':
      var func = state.find(({ id }) => id == action.id);
      // console.log('typeof ',typeof func)
      if(typeof func === 'undefined')
        return state;

      var list = getFunctionsOfType(state, func.triggerId, func.functionType);
      var newFunc = {...func};

      if(typeof newFunc.order !== 'number') {
        // Function without order
        newFunc.order = getNewOrder(list);
        return state.map(tFunc => {
          if(tFunc.id === func.id) {
            return newFunc;
          }
          return tFunc;
        });
      }
      else if (newFunc.order >= list.length -1) {
        return state
      }
      else {
        var newOrder = func.order + 1;
        newFunc.order = newOrder;
        var previousOne = list.find(tFunc => tFunc.order == newOrder);
        if(typeof previousOne == 'undefined')
          console.log('Can\'t find previous one.')
        var newPrevious = {...previousOne};
        newPrevious.order--;

        return state.map(tFunc => {
          if(tFunc.id === func.id) {
            return newFunc;
          }
          else if(tFunc.id === newPrevious.id) {
            return newPrevious;
          }
          return tFunc;
        });
      }
    case 'PUT_UP_FUNCTION':
      var func = state.find(({ id }) => id == action.id);
      if(typeof func === 'undefined')
        return state;

      var list = getFunctionsOfType(state, func.triggerId, func.functionType);
      var newFunc = {...func};

      if(typeof func.order !== 'number') {
        newFunc.order = getNewOrder(list);
        return state.map(tFunc => {
          if(tFunc.id === func.id) {
            return newFunc;
          }
          return tFunc;
        });
      }
      else if (newFunc.order <= 0 )
        return state
      else {
        var newOrder = func.order - 1;
        newFunc.order = newOrder;
        var previousOne = list.find(tFunc => tFunc.order == newOrder);
        if(typeof previousOne == 'undefined')
          console.log('Can\'t find previous one.')
        var newPrevious = {...previousOne};
        newPrevious.order++;

        return state.map(tFunc => {
          if(tFunc.id === func.id) {
            return newFunc;
          }
          else if(tFunc.id === newPrevious.id) {
            return newPrevious;
          }
          return tFunc;
        });
      }
     case 'DELETE_FUNCTION':
      var func = state.find(({ id }) => id == action.id);
      if(typeof func === 'undefined')
        return state;
      var newState = deleteArgsFunction(state, action.id, true)
      return reorderFunctions(newState, func.triggerId, func.functionType)
    case 'DELETE_TRIGGER':
      return state.filter(({triggerId}) => triggerId !== action.id && typeof triggerId !== 'undefined')
    case 'CHANGE_ARG_MODE':
      var func = state.find(({ id }) => id == action.id);
      if(typeof func === 'undefined')
        return state;
      
      var newState = deleteArgFunction(state, func, action.argId);  
      return newState.map(func => {
        if(func.id === action.id) {
          var newFunc = {...func};
          newFunc.args[action.argId] = {
            mode:action.argMode,
            value: getDefaultValue(action.returnType, action.argMode),
          };
          return newFunc;
        }
        return func;
      });
    case 'SELECT_FUNCTION_TYPE':
      var newState = deleteArgsFunction([...state], action.id, false);
      return newState.map(func => {
        if(func.id === action.id) {
          return {...func,
            functionType: action.functionType,
            args: getDefaultArgs(action.functionType),
          };
        }
        return func;
      })
    case 'CHANGE_ARG_VALUE':
      var func = state.find(({ id }) => id == action.id);
      if(typeof func === 'undefined')
        return state;
      var newState = deleteArgFunction(state, func, action.argId);   
      return newState.map(func => {
        if(func.id === action.id) {
          var newFunc = {...func};
          // If a function was set, we delete it.
          var previousArg = newFunc.args[action.argId];
          if(typeof previous === 'object')
            var previousArgFunctionId = previousArg.functionId;
          
          var newArg = {
            mode:action.argMode,
            value:'NULL',
          };
          if(action.argMode == 'FUNCTION') {
            // If it's a function, 
            // If there's already one existing we modify it
            if(previousArgFunctionId >= 0) {
              action.asyncDispatch(selectFunctionType({...action, 
                id:previousArgFunctionId,
                functionType:action.argValue,
                triggerId:func.triggerId,
              }));
            }
            // Otherwise we create a new one
            else {
              action.asyncDispatch(addFunction({...action, 
                parentId:func.id,
                functionType:action.argValue,
                triggerId:func.triggerId,
              }));
            }
          }
          else {
            // Otherwise we delete the previous function
            if(typeof previousArgFunctionId === 'number')
              action.asyncDispatch(deleteFunction({id:previousArgFunctionId}))
            newArg.value = action.argValue;
          }
          newFunc.args[action.argId] = newArg;
          return newFunc;
        }
        else
          return func;
      })
    case 'REGISTER_CHILD_FUNCTION':
      return state.map(func => {
        if(func.id === action.parentId) {
          var newFunc = {...func};
          newFunc.args[action.argId].functionId = action.id;
          return newFunc;
        }
        return func;
      })
// CLIENT ONLY
    case 'PUSH_ACTIVITY_CONTENT':
      if(typeof action.data.functions === 'undefined') {
        log ('Undefined "state.functions" from server.')
        return state;
      }
      else {
        return action.data.functions.map(func => {
          var previousTrigger = state.filter(({ id }) => id === func.id)[0];
          if(typeof previousTrigger !== 'undefined' && previousTrigger.isSelected)
            func.isSelected = true;
          return func;
        });
      }
    case 'SELECT_ECA':
      return state.map(func => {
        if(func.id === action.id) {
          var newFunction = {...func};

          newFunction.isSelected = true;
          return newFunction;
        }
        else if (func.isSelected) {
          var newFunction = {...func};
          newFunction.isSelected = false;
          return newFunction;
        }
        else
          return func;
      })
    case 'SELECT_TRIGGER':
      return state.map(func => {
        if(func.isSelected) {
          var newFunction = {...func};
          newFunction.isSelected = false;
          return newFunction;
        }
        else
          return func;
      })
// SERVER ONLY
    case 'SET_STATE_FROM_DATABASE':
      if(typeof action.state.functions === 'undefined') {
        log ('Undefined "state.functions" from server.')
        return defaultState;
      }
      else
        return action.state.functions;
    default:
      return state
  }
}

// Delete the function and its childs at a specific argId of a parent function func
var deleteArgFunction = function (state, func, argId) {
  var previousArgFunctionId = typeof func.args[argId] !== 'undefined' ? 
    func.args[argId].functionId : -1;
  if(previousArgFunctionId >= 0) {
    return deleteArgsFunction (state, previousArgFunctionId);
  }
  return state;
}

// Delete every child functions of targetId and possibly targetId too
var deleteArgsFunction = function (state, targetId, deleteCurrent = true) {
  if(!targetId || typeof targetId === 'undefined')
    return state;
  var func = state.find(({ id }) => id == targetId);
  if(!func || typeof func === 'undefined')
    return state;
  for(let arg of func.args) {
    if(typeof arg !== null
      && arg.functionId >= 0) {
      state = deleteArgsFunction(state, arg.functionId);
    }
  }
  if(deleteCurrent)
    return state.filter(({ id }) => id !== targetId); 
  else 
    return state;
}


export default functions
